import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import { ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { createEffectFromPreset } from '@/components/DesignStudio/ImageEffectsProperties/utils/effectCreators';
import BodyPresetGridThumbnail from '@/components/DesignStudio/ImageEffectsProperties/components/create/components/body/preset/grid/thumbnail/BodyPresetGridThumbnail.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BodyPresetGrid',
  setup(__props) {

const selectedPreset = computed(() => store.getters['imageEffectsProperties/selectedPreset']);
const groupedPresets = computed(() => store.getters['imageEffectsProperties/groupedFilteredPresets']);

const handlePresetSelect = (preset: ImageEffectPreset) => {
    const effect = createEffectFromPreset(preset);
    store.dispatch('imageEffectsProperties/addImageEffect', effect);
};

return { __sfc: true,selectedPreset, groupedPresets, handlePresetSelect, BodyPresetGridThumbnail }
}

})